export default function () {
    return {
        data: [],
        fields: [
            {
                key: 'id',
                label: 'ID Reserva'
            },
            {
                key: 'placeName',
                label: 'Destino'
            },
            {
                key: 'status',
                label: 'Status'
            },
            {
                key: 'date',
                label: 'Data da reserva'
            },
            {
                key: 'duration',
                label: 'Data da Trip'
            },
            {
                key: 'actions',
                label: 'Ações'
            }
        ]
    }
}